import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const DescriptionText = ({ text }) => <S.Text>{text}</S.Text>;

export default DescriptionText;

DescriptionText.propTypes = {
  text: PropTypes.string.isRequired,
};
